import React, { Component } from "react";
import {
  Paper,
  Container,
  Grid,
  Breadcrumbs,
  Typography,
  Link,
  TextField,
  Button,
  Table,
  TableRow,
  TableBody,
  TableCell
} from "@material-ui/core";
import HomeIcon from "@material-ui/icons/Home";
//objeto firebase
import { consumerFirebase } from "../../server";
//componente para añadir imagenes
import ImageUploader from "react-images-upload";
//genera una clave unica para cada imagen
import { v4 as uuidv4 } from "uuid";
//archivo para modificar las keywords de la funcion saveEditestate del boton de editar
import { createKeyword } from "../../session/actions/Keyword";

const style = {
  container: {
    paddingTop: "8px"
  },
  paper: {
    marginTop: 8,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    backgroundColor: "#f5f5f5"
  },
  link: {
    display: "flex"
  },
  submit: {
    marginTop: 15,
    marginBotton: 10
  },
  photoEstate: {
    height: "150px",
    width: "300px"
  }
};

class EditEstate extends Component {
  state = {
    estate: {
      direction: "",
      city: "",
      country: "",
      description: "",
      inside: "",
      photos: []
    }
  };
  //funcion para capturar datos de los campos del input
  changeDate = e => {
    let estate = Object.assign({}, this.state.estate);
    estate[e.target.name] = e.target.value;
    this.setState({ estate });
  };

  //funcion para subir imagenes
  uploadPhoto = photos => {
    const { estate } = this.state;
    const { id } = this.props.match.params;
    //agregar un nombre dinamico por cada imagen para subirla al firestore
    Object.keys(photos).forEach(key => {
      let id_code = uuidv4();
      let name_photo = photos[key].name;
      let extension = name_photo.split(".").pop();
      //nombre sin extension
      //se le añade un atributo nuevo llamado alias
      photos[key].alias = (
        name_photo.split(".")[0] +
        "_" +
        id_code +
        "." +
        extension
      )
        .replace(/\s/g, "_")
        .toLowerCase();
    });
    //llamamos al metodo de firebase para guardar documentos en bbdd - funcion saveDocuments en server/firebase
    this.props.firebase.saveDocuments(photos).then(list_urls => {
      //creamos dos nuevos campos en bbdd para almacenar nuevos valores
      //estate.photos = list_urls; - sustituye la imagen anterior
      estate.photos = estate.photos.concat(list_urls); //agrega foto a las anteriores
      //llamada al objeto firebase
      this.props.firebase.db
        .collection("Estates")
        .doc(id)
        .set(estate, { merge: true })
        .then(success => {
          this.setState({
            estate
          });
        });
    });
  };

  //funcion para elimimar una foto
  deletePhoto = photo_url => async () => {
    const { estate } = this.state;
    const { id } = this.props.match.params;
    //extraer el codigo unico de la url de la foto de la bbdd mediante codigo regetx
    let id_photo = photo_url.match(/[\w-]+.(jpg|png|jpeg|gif|svg)/);
    //me devuelve el nombre completo con la extension con su id unico
    id_photo = id_photo[0];
    //llamamos a la funcion deleteDocument del objeto firebase
    //elimina la foto del storage
    await this.props.firebase.deleteDocument(id_photo);
    //actualiza el array de fotos
    let photo_list = this.state.estate.photos.filter(photo => {
      return photo !== photo_url;
    });
    //y sustituye las fotos el state
    estate.photos = photo_list;
    //actualiza las fotos en la bbdd
    this.props.firebase.db
      .collection("Estates")
      .doc(id)
      .set(estate, { merge: true })
      .then(success => {
        this.setState({
          estate
        });
      });
  };

  //metodo que se llama cuando el componente ha sido montado
  async componentDidMount() {
    //capturar el codigo de la id del inmueble
    const { id } = this.props.match.params;
    //declarar una instancia del objeto collection antes de ejecutar el query me de la data el inmueble
    const estateCollection = this.props.firebase.db.collection("Estates");
    //traigo la data del inmueble mediante el id
    const estateDB = await estateCollection.doc(id).get();
    this.setState({
      //data() es un archivo json que viene desde la bbdd
      estate: estateDB.data()
    });
  }

  //funcion para el boton de guardar edicion de inmueble
  saveEditestate = () => {
    const { estate } = this.state;
    const { id } = this.props.match.params;
    //cambiar las keywords de el inmueble editado
    //determina en que campos va a buscar para mostrar los resultados de la busqueda
    //llamamos a la funcion createKeyword() del archivo Keyword.js
    const editTextKeyword =
      estate.direction + " " + estate.city + " " + estate.country;
    let keywordsEdit = createKeyword(editTextKeyword);
    //campo de la BBDD
    estate.keywords = keywordsEdit;
    
    //codigo añadido despues del login por telefono
    //agrega la logica para añadir campo a la coleccion de estates el id de usuario, a fin de que en su sesion se vean los estates registrados por él
    //creamos nuevo campo owner
    estate.owner = this.props.firebase.auth.currentUser.uid;

    //lamada a la BBDD
    this.props.firebase.db
      .collection("Estates")
      .doc(id)
      .set(estate, { merge: true })
      .then(success => {
        this.props.history.push("/");
      });
  };

  render() {
    // id unica para el imageUploader key
    let uniqueID = uuidv4();

    return (
      <Container style={style.container}>
        <Paper style={style.paper}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={8}>
              <Breadcrumbs aria-label="breadcrumb">
                <Link color="inherit" style={style.link} href="/">
                  <HomeIcon />
                  Home
                </Link>
                <Typography color="textPrimary">Edit estate</Typography>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                name="direction"
                label="Direction of estate"
                fullWidth
                value={this.state.estate.direction}
                onChange={this.changeDate}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="city"
                label="City"
                fullWidth
                value={this.state.estate.city}
                onChange={this.changeDate}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="country"
                label="Country"
                fullWidth
                value={this.state.estate.country}
                onChange={this.changeDate}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                name="description"
                label="Description"
                fullWidth
                rowsMax="4"
                multiline
                value={this.state.estate.description}
                onChange={this.changeDate}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                name="inside"
                label="Inside"
                fullWidth
                rowsMax="4"
                value={this.state.estate.inside}
                onChange={this.changeDate}
              />
            </Grid>
          </Grid>

          <Grid container justify="center">
            <Grid item xs={12} sm={6}>
              <ImageUploader
                key={uniqueID}
                withIcon={true}
                buttonText="select images"
                onChange={this.uploadPhoto}
                imgExtension={[".jpg", ".gif", ".png", ".jpeg"]}
                maxFileSize={5242880} //5 MB
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Table>
                <TableBody>
                  {this.state.estate.photos
                    ? this.state.estate.photos.map((photo, i) => (
                        <TableRow key={i}>
                          <TableCell align="left">
                            <img
                              src={photo}
                              alt={photo.name}
                              style={style.photoEstate}
                            />
                            <TableCell align="left">
                              <Button
                                variant="contained"
                                color="secondary"
                                size="small"
                                onClick={this.deletePhoto(photo)}
                              >
                                Delete...
                              </Button>
                            </TableCell>
                          </TableCell>
                        </TableRow>
                      ))
                    : ""}
                </TableBody>
              </Table>
            </Grid>
          </Grid>

          <Grid container justify="center">
            <Grid item xs={12} sm={6}>
              <Button
                type="button"
                fullWidth
                variant="contained"
                size="large"
                color="primary"
                style={style.submit}
                onClick={this.saveEditestate}
              >
                Editar...
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Container>
    );
  }
}

export default consumerFirebase(EditEstate);
